// @flow

import { useEffect } from 'react';

import { useTrackingContext } from '@zapier/tracking';

import useSelectedApis from 'web-ssr/app/app-directory/hooks/useSelectedApis';

type Props = {
  primaryService: {
    id: string,
    slug: string,
  },
  secondaryService: ?{
    id: string,
    slug: string,
  },
};

const useServiceTracking = ({ primaryService, secondaryService }: Props) => {
  const { trackEvent } = useTrackingContext();

  const selectedApis = useSelectedApis({
    primaryAppSlug: primaryService.slug,
    secondaryAppSlug: secondaryService && secondaryService.slug,
  });

  const primaryServiceId = selectedApis && selectedApis[0];
  const primaryServiceSlug = primaryService && primaryService.slug;
  const secondaryServiceId = selectedApis && selectedApis[1];
  const secondaryServiceSlug = secondaryService && secondaryService.slug;

  useEffect(() => {
    trackEvent('service_page_landed', {
      primaryServiceId,
      primaryServiceSlug,
      secondaryServiceId,
      secondaryServiceSlug,
    });
  }, [
    trackEvent,
    primaryServiceId,
    primaryServiceSlug,
    secondaryServiceId,
    secondaryServiceSlug,
  ]);
};

export default useServiceTracking;
